// src/components/PasswordProtection/PasswordProtection.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './PasswordProtection.css';

const PasswordProtection = ({ onAccessGranted }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const correctPassword = 'W26';

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Simulate a brief loading state for better UX
    setTimeout(() => {
      if (password === correctPassword) {
        onAccessGranted();
      } else {
        setError('Incorrect password. Please try again.');
        setPassword('');
      }
      setIsLoading(false);
    }, 500);
  };

  return (
    <div className="password-protection-overlay">
      <motion.div 
        className="password-protection-container"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="password-form-wrapper">
          {/* Logo */}
          

          <h1 className="password-title">Access Required</h1>
          <p className="password-subtitle">
            Please enter the password to access GusHome
          </p>

          <form onSubmit={handleSubmit} className="password-form">
            <div className="password-input-wrapper">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className={`password-input ${error ? 'error' : ''}`}
                autoFocus
                disabled={isLoading}
              />
            </div>

            {error && (
              <motion.div 
                className="password-error"
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3 }}
              >
                {error}
              </motion.div>
            )}

            <button 
              type="submit" 
              className="password-submit-btn"
              disabled={isLoading || !password.trim()}
            >
              {isLoading ? (
                <div className="loading-spinner"></div>
              ) : (
                'Access Website'
              )}
            </button>
          </form>

          <div className="password-footer">
            <p>Need access? Contact the GusHome team.</p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PasswordProtection;